import { feedCards } from '@/mocks/chiguaData';

export default function Feed() {
  return (
    <section id="feed" className="bg-background-100/70 py-16 md:py-24 scroll-mt-20">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <div className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-focus-3-line text-lg"></i>吃瓜速递
            </div>
            <h2 className="mt-3 font-heading text-3xl md:text-[42px] font-black leading-snug text-foreground-950">
              最新瓜田，一图看懂
            </h2>
            <p className="mt-3 max-w-2xl text-foreground-600 text-base leading-relaxed">
              图文并茂的即时内容流，热点、梗、现场、盘点持续上新。喜欢的记得先点进官网入口收藏，常看常新。
            </p>
          </div>
          <button
            onClick={() => {
              const el = document.getElementById('entrance');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="shrink-0 inline-flex items-center justify-center gap-2 rounded-full border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 bg-background-50 px-6 py-2.5 text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer"
          >
            查看更多
            <i className="ri-arrow-right-line text-base"></i>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {feedCards.map((c, i) => (
            <article key={c.title} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-3xl bg-background-200">
                <img
                  src={c.img}
                  alt={c.title}
                  title={`${c.title} - 吃瓜网站`}
                  className="aspect-[3/2] w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/90 backdrop-blur-sm px-3 py-1 text-xs font-semibold text-foreground-800">
                  {c.tag}
                </span>
                <span className="absolute left-4 bottom-4 rounded-full bg-primary-500 text-background-50 px-3 py-1 text-xs font-semibold">
                  新 · {i + 1}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg md:text-xl font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                {c.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{c.desc}</p>
              <div className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-user-smile-line"></i>
                {c.meta}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}